<template>
	<div>
		<a href="#" class="back-top-button">
			<i class="fa fa-chevron-up"></i>
		</a>
		<a href="#" class="back-top-link">Back to Top</a>
	</div>
</template>

<script>
export default {
	name: 'FooterScrollToTop',
}
</script>



// WEBPACK FOOTER //
// src/components/footer/FooterScrollToTop.vue